import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { fmt, fmtS, dateStr } from './formatters'

const calcUP = (comps, field = 'price') => {
  return comps.reduce((s, c) => s + c.coefficient * (c[field] || c.price || 0), 0)
}

export const exportRABToPDF = (project, rabItems, categories, oh, ppn) => {
  const doc = new jsPDF()

  doc.setFontSize(16)
  doc.setTextColor(245, 158, 11)
  doc.text('UNDAGI - RAB & AHS', 14, 20)

  doc.setFontSize(12)
  doc.setTextColor(0, 0, 0)
  doc.text(`Proyek: ${project?.name || '-'}`, 14, 30)
  doc.text(`Tanggal Export: ${dateStr(new Date().toISOString())}`, 14, 36)

  const gB = categories.reduce((s, c) => s + c.budget, 0)
  const gR = categories.reduce((s, c) => s + c.real, 0)
  const gtB = gB * (1 + oh / 100) * (1 + ppn / 100)
  const gtR = gR * (1 + oh / 100) * (1 + ppn / 100)

  doc.setFontSize(10)
  doc.text('RINGKASAN', 14, 46)

  autoTable(doc, {
    startY: 50,
    head: [['Item', 'Anggaran', 'Realisasi', 'Selisih']],
    body: [
      ['Sub Total', fmt(gB), fmt(gR), fmt(gB - gR)],
      [`OH & Profit (${oh}%)`, fmt(gB * oh / 100), fmt(gR * oh / 100), fmt((gB - gR) * oh / 100)],
      [`PPN (${ppn}%)`, fmt(gB * (1 + oh / 100) * ppn / 100), fmt(gR * (1 + oh / 100) * ppn / 100), fmt((gB - gR) * (1 + oh / 100) * ppn / 100)],
      ['GRAND TOTAL', fmt(gtB), fmt(gtR), fmt(gtB - gtR)]
    ],
    theme: 'grid',
    headStyles: { fillColor: [245, 158, 11] },
    styles: { fontSize: 9 }
  })

  doc.save(`RAB-${project?.name || 'Proyek'}.pdf`)
}

export const exportInvoiceToPDF = (invoice, project) => {
  const doc = new jsPDF()

  doc.setFontSize(18)
  doc.setTextColor(245, 158, 11)
  doc.text('INVOICE', 14, 20)

  doc.setFontSize(12)
  doc.setTextColor(0, 0, 0)
  doc.text(`No. Termin: ${invoice.term_number}`, 14, 30)
  doc.text(`Proyek: ${project?.name || '-'}`, 14, 36)
  doc.text(`Tanggal: ${dateStr(invoice.date)}`, 14, 42)
  doc.text(`Jatuh Tempo: ${dateStr(invoice.due_date)}`, 14, 48)

  doc.setFontSize(14)
  doc.text('Total Tagihan:', 14, 60)
  doc.setFontSize(18)
  doc.setTextColor(245, 158, 11)
  doc.text(fmt(invoice.amount), 14, 70)

  doc.setFontSize(11)
  doc.setTextColor(0, 0, 0)
  doc.text('Deskripsi:', 14, 85)
  doc.setFontSize(10)
  doc.text(invoice.description, 14, 92, { maxWidth: 180 })

  doc.save(`Invoice-T${invoice.term_number}-${project?.name || 'Proyek'}.pdf`)
}

export const exportReportToPDF = (report, project, photos) => {
  const doc = new jsPDF()

  doc.setFontSize(16)
  doc.setTextColor(245, 158, 11)
  doc.text('LAPORAN HARIAN', 14, 20)

  doc.setFontSize(12)
  doc.setTextColor(0, 0, 0)
  doc.text(`Proyek: ${project?.name || '-'}`, 14, 30)
  doc.text(`Tanggal: ${dateStr(report.date)}`, 14, 36)
  doc.text(`Cuaca: ${report.weather}`, 14, 42)

  doc.setFontSize(10)
  autoTable(doc, {
    startY: 50,
    head: [['Supervisor', 'Jumlah Pekerja']],
    body: [[report.supervisor || '-', `${report.workers_count || 0} orang`]],
    theme: 'grid',
    headStyles: { fillColor: [245, 158, 11] }
  })

  doc.text('Pekerjaan:', 14, doc.lastAutoTable.finalY + 15)
  doc.setFontSize(10)
  const splitActivities = doc.splitTextToSize(report.activities || '-', 180)
  doc.text(splitActivities, 14, doc.lastAutoTable.finalY + 22)

  if (report.issues) {
    doc.text('Kendala:', 14, doc.lastAutoTable.finalY + 35)
    doc.setTextColor(248, 81, 73)
    const splitIssues = doc.splitTextToSize(report.issues, 180)
    doc.text(splitIssues, 14, doc.lastAutoTable.finalY + 42)
  }

  doc.save(`Laporan-${dateStr(report.date)}.pdf`)
}